<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24" v-if="!isCommunityRole">
              <a-form-item :label="$t('社区账单.社区名称')">
                <a-input v-model="queryParam.communityName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('社区账单.账单类型')">
                <a-select v-model="queryParam.billType" allowClear style="width: 100%">
                  <a-select-option v-for="(item, index) in customDict.CommunityBillTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('社区账单.支付状态')">
                <a-select v-model="queryParam.payStatus" allowClear style="width: 100%">
                  <a-select-option v-for="(item, index) in customDict.CommunityPayStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('社区账单.账单年月')">
                <a-month-picker v-model="queryParam.billMonthFormat" style="width: 100%" format="YYYY-MM" value-format="YYYY-MM" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('社区账单.用户信息')">
                <a-input v-model="queryParam.userInfo" @pressEnter="handleQuery" allow-clear :placeholder="$t('社区账单.用户信息搜索提示')"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['homeservice:bill:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['homeservice:bill:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="billType" slot-scope="text, record">
          {{ record.billTypeName }}
        </span>
        <span slot="userInfo" slot-scope="text, record">
          {{ $t('社区账单.用户昵称') }}：{{ record.nickName || '-' }} <br/>
          {{ $t('社区账单.手机号') }}：{{ record.mobile || '-' }} <br/>
        </span>
        <span slot="payStatus" slot-scope="text, record">
          <a-tag :color="record.payStatus === 1 ? 'green' : 'orange'">
            {{ record.payStatusName }}
          </a-tag>
        </span>
        <span slot="totalFee" slot-scope="text, record">
          ¥{{ record.totalFee }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleUpdate(record)" v-hasPermi="['homeservice:bill:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['homeservice:bill:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 新增/编辑表单 -->
    <create-form ref="createForm" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageBill, delBill } from '@/api/homeservice/bill'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import auth from '@/plugins/auth'

export default {
  name: 'HomeCommunityBill',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      currentCommunityId: null, // 当前用户关联的社区ID
      queryParam: {
        communityName: undefined,
        billType: undefined,
        payStatus: undefined,
        billMonthFormat: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('社区账单.社区名称'), dataIndex: 'communityName', width: 120 },
        { title: this.$t('社区账单.用户信息'), dataIndex: 'userInfo', scopedSlots: { customRender: 'userInfo' }, width: 180 },
        { title: this.$t('社区账单.房间号'), dataIndex: 'roomNumber', width: 100 },
        { title: this.$t('社区账单.账单类型'), dataIndex: 'billType', scopedSlots: { customRender: 'billType' }, width: 100 },
        { title: this.$t('社区账单.账单年月'), dataIndex: 'billMonth', width: 100 },
        { title: this.$t('社区账单.账单金额'), dataIndex: 'totalFee', scopedSlots: { customRender: 'totalFee' }, width: 100 },
        { title: this.$t('社区账单.支付状态'), dataIndex: 'payStatus', scopedSlots: { customRender: 'payStatus' }, width: 100 },
        { title: this.$t('社区账单.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 150 }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    // 是否是社区角色（只要角色列表中包含 shequ 就算）
    isCommunityRole() {
      const roles = this.$store.getters.roles || []
      return roles.includes('shequ')
    }
  },
  created() {
    // 如果是社区角色，获取关联的社区ID
    if (this.isCommunityRole) {
      this.getCurrentCommunityId()
    }
    this.getList()
  },
  methods: {
    hasRole(role) {
      return auth.hasRole(role)
    },
    getCurrentCommunityId() {
      // 动态导入避免循环依赖
      import('@/api/homeservice/bill').then(module => {
        module.getCommunityId().then(response => {
          this.currentCommunityId = response.data
        })
      })
    },
    getList() {
      this.loading = true
      const param = { ...this.queryParam }
      if (this.queryParam.billMonthFormat) {
        param.billMonth = this.queryParam.billMonthFormat
      }
      // userInfo 搜索框同时搜索昵称和手机号（OR关系），后端接收字段为 nickName
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      pageBill(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        communityName: undefined,
        billType: undefined,
        payStatus: undefined,
        billMonthFormat: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    handleAdd() {
      this.$refs.createForm.handleAdd(this.currentCommunityId)
    },
    handleUpdate(row) {
      this.$refs.createForm.handleUpdate(row, this.currentCommunityId)
    },
    handleDelete(row) {
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk: () => {
          const data = (Array.isArray(ids) ? ids : [ids]).map(id => ({ id }))
          return delBill(data).then(() => {
            this.selectedRowKeys = []
            this.getList()
            this.$message.success(this.$t('通用.文本.删除成功'))
          })
        }
      })
    }
  }
}
</script>
